import {
  Box,
  FormHelperText,
  TextField as MUITextField,
  TextFieldProps as MUITextFieldProps,
  Typography,
} from '@mui/material';
import { useRef } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

interface TextFieldCustomProps {
  height?: string | number;
  width?: string | number;
  maxLength?: number;
  register?: UseFormRegisterReturn;
  error?: boolean;
  helperText?: string;
}

type TextFieldProps = TextFieldCustomProps & MUITextFieldProps;

const TextField = ({ helperText, ...props }: TextFieldProps) => {
  const textFieldRef = useRef<HTMLInputElement | null>();

  return (
    <>
      <Box position="relative">
        <MUITextField
          inputRef={textFieldRef}
          // id="input-textfield"
          {...props.register}
          error={props.error}
          variant="outlined"
          fullWidth
          sx={{
            border: 'none',
            '& .MuiInputBase-input': {
              backgroundColor: '#F6F7F8 !important',
              borderRadius: '4px',
              '&::placeholder': {
                color: 'text.secondary',
                opacity: '100',
              },
            },
            '& .MuiSvgIcon-root': {
              backgroundColor: 'unset',
            },
          }}
          multiline
          select={false}
          inputProps={{
            style: {
              height: props.height || '100px',
              padding: '20px 16px',
            },
            maxLength: props.maxLength || 500,
          }}
          InputProps={{
            style: {
              padding: 0,
            },
          }}
          {...props}
        />
        <Box position="absolute" bottom={0} right={0} padding={1}>
          <Typography
            variant="body3"
            color={theme => theme.palette.text.primary}
            fontSize="12px"
          >
            {textFieldRef?.current?.value?.length ?? 0}/{props.maxLength}
          </Typography>
        </Box>
      </Box>

      {helperText && (
        <FormHelperText
          id="helper-text"
          sx={{ color: 'primary.main', m: '3px 14px 0' }}
        >
          {helperText}
        </FormHelperText>
      )}
    </>
  );
};

export default TextField;
